module.exports = __webpack_public_path__ + "img/mobile-work-background.e0dc7716.jpg";